import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export var base64Encode = function base64Encode(str) {
  return Buffer.from(str).toString('base64');
};
export var base64Decode = function base64Decode(str) {
  return new Buffer(str, 'base64').toString('utf8');
};